import React from 'react';
import GlassCard from './GlassCard';

/** Small number card. tone: 'gold' | 'green' | 'red' | undefined */
export default function GlassStat({ label, value, tone }) {
  return (
    <GlassCard>
      <div className="glass-stat__label">{label}</div>
      <div className={`glass-stat__value ${tone ? `glass-stat__value--${tone}` : ''}`}>{value}</div>
    </GlassCard>
  );
}